import actions from './actions';
import type { AppState } from './models';

const initialState: AppState = {
  sidebarCollapsed: true,
  actionDrawerCollapsed: false,
  editStatus: undefined,
  cropwiseApps: [],
  cropwiseAppsStatus: 'idle',
  quickTip: undefined,
  quickTipLeft: undefined,
  showCongratulationsPlanet: false,
};

const reducer = (state = initialState, action: any): AppState => {
  switch (action.type) {
    case actions.TOGGLE_SIDEBAR:
      return {
        ...state,
        sidebarCollapsed: !state.sidebarCollapsed,
      };
    case actions.TOGGLE_ACTION_DRAWER:
      return {
        ...state,
        actionDrawerCollapsed: !state.actionDrawerCollapsed,
      };
    case actions.SET_EDIT_STATUS:
      return {
        ...state,
        editStatus: action.payload,
      };
    case actions.LOAD_APPS.started().type:
      return {
        ...state,
        cropwiseAppsStatus: 'loading',
      };
    case actions.LOAD_APPS.success().type:
      return {
        ...state,
        cropwiseApps: action.payload,
        cropwiseAppsStatus: 'success',
      };
    case actions.LOAD_APPS.error().type:
      return {
        ...state,
        cropwiseAppsStatus: 'error',
      };
    case actions.TOGGLE_CONGRATULATIONS_PLANET:
      return {
        ...state,
        showCongratulationsPlanet: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
